import React from "react"
import { Input, FormField } from "@bw/forms"
import { Button } from "@bw/bits"
import { Formik, Form } from "formik"
import * as css from "./PasswordProtection.module.css"
import { useTranslation } from "react-i18next"

export const PasswordProtection = ({ onSubmit }) => {
  const { t } = useTranslation()

  return (
    <div className={css.wrapper}>
      <div className={css.panel}>
        <h1 className={css.title}>{t("protection.title")}</h1>
        <Formik
          initialValues={{ password: "" }}
          onSubmit={values => {
            onSubmit(values.password)
          }}
        >
          {({ handleChange, isSubmitting }) => (
            <div>
              <Form>
                <FormField
                  name="password"
                  title={t("protection.password")}
                  required
                >
                  <Input name="password" onChange={handleChange} />
                </FormField>
                <Button
                  type="submit"
                  label={t("protection.check")}
                  disabled={isSubmitting}
                />
              </Form>
            </div>
          )}
        </Formik>
      </div>
    </div>
  )
}
